<template>
  <div class="footer-nhrdn bg-secondary pt-12">
    <div class="flex flex-wrap">
      <div class="md:w-1/2 w-full lg:w-1/2 lg:pl-12 md:pl-12 pl-5">
        <div class="w-full flex">
          <div class="md:w-1/2 w-full lg:w-1/2">
            <img
              src="@/assets/img/nHRd.png"
              alt="NHRDN LOGO"
              class="md:w-1/2 w-1/4 lg:w-2/3"
            />
            <div class="w-full md:pt-6 lg:pt-6 pt-2">
              <p class="font-bold fsize20 text-white">Download NHRD App</p>
              <p class="font-bold text-white fsize16">
                Now available on playstore & appstore
              </p>
              <div class="flex items-center py-4">
                <a
                  href="https://play.google.com/store/apps/details?id=com.nhrdn"
                  ><img
                    src="@/assets/img/gplay.png"
                    alt="google Play"
                    class="md:h-12 lg:h-12 wid h-9 wido rounded-lg"
                  />
                </a>
                <a href="https://apps.apple.com/in/app/nhrdn/id1605749499"
                  ><img
                    src="@/assets/img/appstore.png"
                    alt="google Play"
                    class="md:h-12 lg:h-12 h-9 wid wido rounded-lg ml-4"
                /></a>
              </div>
              <div class="grid grid-cols-5 gap-2 ml-2 py-4">
                <a
                  href="https://www.linkedin.com/in/national-hrd-network/"
                  target="_blank"
                  ><img
                    src="@/assets/img/linkedin.png"
                    alt="NHRDN LOGO"
                    class="h-6"
                /></a>
                <a href="https://www.facebook.com/nhrdncentral" target="_blank"
                  ><img src="@/assets/img/fb.png" alt="NHRDN LOGO" class="h-6"
                /></a>
                <!-- <a href=""
                  ><img src="@/assets/img/ig.png" alt="NHRDN LOGO" class="h-6"
                /></a> -->
                <a href="https://twitter.com/nhrdn" target="_blank"
                  ><img
                    src="@/assets/img/twitter.png"
                    alt="NHRDN LOGO"
                    class="h-6"
                /></a>

                <a
                  href="https://www.youtube.com/@NationalHRDNetworkOfficial"
                  target="_blank"
                >
                  <feather-icon
                    icon="YoutubeIcon"
                    class="text-fb"
                    svgClasses="w-8 h-8"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="w-1/2 mob-hidden">
            <img
              src="@/assets/img/ftr-logo1.png"
              alt="NHRDN LOGO"
              class="w-2/3 mx-auto mt-3 rounded-t-2xl"
            />
          </div>
        </div>
      </div>
      <div
        class="md:w-1/2 w-full lg:w-1/2 lg:pl-0 md:pl-0 pl-5 lg:pr-12 md:pr-12 pr-5"
      >
        <div class="w-full flex flex-wrap justify-between md:px-4 lg:px-4">
          <div class="sm-ftr-width">
            <p class="ftr-ttl pb-2">Solutions</p>
            <p
              class="ftr-ttl opacity-75 cursor-pointer py-1"
              @click="handleClick('network')"
            >
              Network
            </p>
            <p
              class="ftr-ttl cursor-pointer opacity-75 py-1"
              @click="handleClick('job')"
            >
              Jobs
            </p>
            <p
              class="ftr-ttl cursor-pointer opacity-75 py-1"
              @click="handleClick('upskill')"
            >
              Upskill
            </p>
            <p
              class="ftr-ttl cursor-pointer opacity-75 py-1"
              @click="handleClick('chapters')"
            >
              Chapters
            </p>
          </div>
          <div class="sm-ftr-width">
            <p class="ftr-ttl pb-2">Explore</p>
            <p
              class="ftr-ttl opacity-75 py-1 cursor-pointer"
              @click="handleClick('discover')"
            >
              Discover
            </p>
            <p
              class="ftr-ttl opacity-75 py-1 cursor-pointer"
              @click="handleClick('events')"
            >
              Events
            </p>
            <!-- <p
              class="ftr-ttl opacity-75 py-1 cursor-pointer"
              @click="handleClick('initiatives')"
            >
              Initiatives
            </p> -->
            <p
              class="ftr-ttl opacity-75 cursor-pointer py-1"
              @click="handleClick('initiatives')"
            >
              Initiative
            </p>
            <p
              class="ftr-ttl opacity-75 cursor-pointer py-1"
              @click="handleClick('e-commerce')"
            >
              Ecommerce
            </p>
          </div>
          <div class="sm-ftr-width">
            <p class="ftr-ttl pb-2">Knowledge hub</p>
            <p
              class="ftr-ttl opacity-75 py-1 cursor-pointer"
              @click="handleClick('resources')"
            >
              Blogs / Podcasts
            </p>
            <p
              class="ftr-ttl opacity-75 cursor-pointer py-1"
              @click="handleClick('awards')"
            >
              Awards
            </p>
            <a
              href="https://nimbuscluster.blob.core.windows.net/server01/nhrdn/image/pdf_20220802_115642_0000%20(1).pdf"
              target="_blank"
              ><p class="ftr-ttl opacity-75 py-1">Brand assets</p></a
            >
            <p class="ftr-ttl opacity-75 py-1 cursor-pointer">
              <a href="https://nhrd.edorer.com" class="hover:text-white"
                >Certifications</a
              >
            </p>
            <p class="ftr-ttl opacity-75 py-1 cursor-pointer">
              <a
                href="https://www.youtube.com/@NationalHRDNetworkOfficial"
                target="_blank"
                >Our videos</a
              >
            </p>
          </div>
          <div class="sm-ftr-width">
            <p class="ftr-ttl pb-2">Account</p>
            <div v-if="!isLoggedIn">
              <p
                class="ftr-ttl opacity-75 py-1 cursor-pointer"
                @click="handleOpenLogin"
              >
                Sign in / Register
              </p>
            </div>
            <!-- <p
              class="ftr-ttl opacity-75 py-1 cursor-pointer"
              @click="openRegForm"
            >
              Register
            </p> -->
            <div>
              <p
                v-if="isLoggedIn && idMatched == true"
                class="ftr-ttl opacity-75 py-1 cursor-pointer"
                @click="handleClick('membership')"
              >
                Upgrade Membership
              </p>
              <p
                v-else
                class="ftr-ttl opacity-75 py-1 cursor-pointer"
                @click="handleClick('membership')"
              >
                Membership
              </p>
            </div>
            <p
              class="ftr-ttl opacity-75 py-1 cursor-pointer"
              @click="IsLoggedIn ? handleClick('chapters') : handleOpenLogin()"
            >
              Community
            </p>
            <p
              class="ftr-ttl opacity-75 py-1 cursor-pointer"
              @click="handleClick('connect')"
            >
              Contact us
            </p>
          </div>
        </div>
        <hr class="my-8 mob-hidden" />
      </div>
      <div
        class="md:flex lg:flex justify-between py-4 w-full px-2 bg-primary mobg text-center"
      >
        <p class="fsize14 opacity-75 text-white">
          Copyright 2022 NHRD Network, All rights reserved
        </p>
        <p
          class="fsize14 opacity-75 cursor-pointer text-white"
          @click="handleClick('privacy-policy')"
        >
          Terms of Use & Privacy Policy
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      idMatched: false,
    };
  },
  methods: {
    async verification() {
      // console.log("hi");
      let data1;
      if (this.user.membershipId.length != 0) {
        let payload = [];

        for (let i = 0; i < this.user.membershipId.length; i++) {
          payload.push(this.user.membershipId[i]);
        }

        data1 = await this.$store.dispatch("membership/verification", payload);

        try {
          const record = this.allMemberships.filter(
            (x) => x.type == "Individual" || x.type == "Institutional"
          );
          // console.log("record", record);
          for (let i = 0; i < record.length; i++) {
            if (record[i]._id === data1.data.membership.membershipPlan) {
              this.idMatched = true;
            }
          }
          // console.log(data[0]._id);
        } catch (err) {
          console.log(err);
        }
      }
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    openRegForm() {
      this.innerVisible = true;
      this.outerVisible = false;
    },
    handleOpenLogin() {
      this.$store.commit("UI/OPEN_LOGIN_POP", true);
      // this.Profile = true;
    },
  },
  mounted() {
    this.verification();
    // console.log(this.user);
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("membershipPlan", ["allMemberships"]),
    isLoggedIn() {
      if (this.user && Object.keys(this.user).length) {
        // this.profile = true;
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    // console.log(this.user);
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      if (this.user && Object.keys(this.user).length) {
        // this.profile = true;
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
